import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import config from "@/middlewares/config"

const notificationRoutes: RouteRecordRaw[] = [
  {
    path: "/notifications",
    name: "notification-center",
    component: () => import("@/views/notifications/NotificationCenter.vue"),
    meta: {
      requiresConfig: true,
      middleware: [auth, config],
      title: "notification_center.page_title",
      hideAside: true,
    },
  },
]

export default notificationRoutes
